import { Api } from "../..";
import {
  API_DELETE_CMS_CONTENT,
  API_GET_CMS_CONTENT,
  API_GET_CMS_CONTENT_TYPES,
  API_POST_CMS_CREATE_CONTENT,
  API_POST_CMS_CREATE_CONTENT_TYPE,
  API_POST_CMS_UPDATE_CONTENT,
} from "../../Apis/ApiEndPoints";
import {
  ICreateContentResponse,
  IGetCMSContentTypes,
  ICreateContentTypePayload,
  ICreateContentPayload,
  IUpdateContentPayload,
} from "../../models/admin/cms/contentTypes";

import { CustomAction } from "./../../store/customAction";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getContentTypes = createAsyncThunk(
  "cms/getContentTypes",
  async (_, { dispatch }) => {
    const response: IGetCMSContentTypes = await CustomAction(
      Api.get(API_GET_CMS_CONTENT_TYPES),
      dispatch,
      "cms/getContentTypes"
    );
    return response;
  }
);

export const createContentType = createAsyncThunk(
  "cms/createContentType",
  async (requestPayload: ICreateContentTypePayload, { dispatch }) => {
    const response: ICreateContentResponse = await CustomAction(
      Api.post(API_POST_CMS_CREATE_CONTENT_TYPE, requestPayload),
      dispatch,
      "cms/createContentType"
    );
    return response;
  }
);

export const createContent = createAsyncThunk(
  "cms/createContent",
  async (requestPayload: ICreateContentPayload, { dispatch }) => {
    const response: ICreateContentResponse = await CustomAction(
      Api.post(API_POST_CMS_CREATE_CONTENT, requestPayload),
      dispatch,
      "cms/createContent"
    );
    return response;
  }
);

export const updateContent = createAsyncThunk(
  "cms/updateContent",
  async (requestPayload: IUpdateContentPayload, { dispatch }) => {
    const { id, ...payloadWithoutId } = requestPayload;
    const response: ICreateContentResponse = await CustomAction(
      Api.post(
        `${API_POST_CMS_UPDATE_CONTENT}/${requestPayload?.id}`,
        payloadWithoutId
      ),
      dispatch,
      "cms/updateContent"
    );
    return response;
  }
);

export const getContent = createAsyncThunk(
  "cms/getContent",
  async (_, { dispatch }) => {
    const response: IGetCMSContentTypes = await CustomAction(
      Api.get(API_GET_CMS_CONTENT),
      dispatch,
      "cms/getContent"
    );
    return response;
  }
);

export const deleteContent = createAsyncThunk(
  "cms/deleteContent",
  async (contentId: string, { dispatch }) => {
    const response: IGetCMSContentTypes = await CustomAction(
      Api.delete(`${API_DELETE_CMS_CONTENT}/${contentId}`),
      dispatch,
      "cms/deleteContent"
    );
    return response;
  }
);
